import DocActivityHeader from './DocActivityHeader';

export default DocActivityHeader;
